export var modalVisible = false;

export function initDialog() {
	(function ($) {

		'use strict';

		$('.modal-link').click(function(event) {

			var dialogId = $(this).data('id');
			toggleDialog(dialogId);
		});

		$('.dialog-hamburger').click(function(event) {
			closeDialog();
		});

	})(jQuery);
}

var dialogActiveClassName = 'dialog-active';

export function toggleDialog(dialogId) {
	(function ($) {
		'use strict';

		var duration = 400;
		if (modalVisible) duration = 0;

		$.ui.dialog.prototype._focusTabbable = function(){};

		$('.ui-dialog').find('.dialog-content').dialog('destroy');

		modalVisible = true;

		var winWidth = $(window).width(),
		winHeight = $(window).height(),
		isDevice = ((winWidth < 640)?true:false);

		var dialogW = ((isDevice)?winWidth-20:500),
		dialogH = ((isDevice)?winHeight-20:500),
		dialogPosition = ((isDevice)?
			{ my: "center center", at: "center center", of: 'body' }
			:{ my: "center center", at: "center center", of: 'body' });

		var dialogClass = (/*(dialogId < 1000)?*/ 'modal modal--news' /*:'modal'*/); // @manuel I couldn't trace why this Id < 1000 was there,
        //and it broke the jobs page, as the IDs started to grow bigger than 1000. So I disabled this

		$('.dialog-content[data-id="'+dialogId+'"]').dialog({
			appendTo: '.container',
			title: '',
			dialogClass: dialogClass,
			draggable: false,
			position: dialogPosition,
			resizable: false,
			show: { effect: "fadeIn", duration: duration },
			hide: { effect: "fadeOut", duration: 400 },
			width: dialogW,
			height: dialogH,
			create: function(event, ui) {
				$('.jsScrollWrapper').addClass(dialogActiveClassName);
			},
		}).parent().draggable();
	})(jQuery);
}

export function closeDialog() {
	(function ($) {

		'use strict';

		$('.ui-dialog').find('.dialog-content').dialog('close');
		$('.jsScrollWrapper').removeClass(dialogActiveClassName);
		modalVisible = false;

	})(jQuery);
}
